module.exports = __webpack_public_path__ + "static/media/geesaa_7.c58c87d0.jpg";